import { render, staticRenderFns } from "./scoreAlert.vue?vue&type=template&id=544f3dc2&"
import script from "./scoreAlert.vue?vue&type=script&lang=js&"
export * from "./scoreAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports